/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AllowedRulesResponseModel } from './AllowedRulesResponseModel';
import {
    AllowedRulesResponseModelFromJSON,
    AllowedRulesResponseModelFromJSONTyped,
    AllowedRulesResponseModelToJSON,
} from './AllowedRulesResponseModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfIEnumerableOfAllowedRulesResponseModel
 */
export interface ResultOfIEnumerableOfAllowedRulesResponseModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<AllowedRulesResponseModel>}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    data?: Array<AllowedRulesResponseModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIEnumerableOfAllowedRulesResponseModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfIEnumerableOfAllowedRulesResponseModel interface.
 */
export function instanceOfResultOfIEnumerableOfAllowedRulesResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfIEnumerableOfAllowedRulesResponseModelFromJSON(json: any): ResultOfIEnumerableOfAllowedRulesResponseModel {
    return ResultOfIEnumerableOfAllowedRulesResponseModelFromJSONTyped(json, false);
}

export function ResultOfIEnumerableOfAllowedRulesResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIEnumerableOfAllowedRulesResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(AllowedRulesResponseModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfIEnumerableOfAllowedRulesResponseModelToJSON(value?: ResultOfIEnumerableOfAllowedRulesResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(AllowedRulesResponseModelToJSON)),
        'Count': value.count,
    };
}

